<template>
  <el-date-picker
    :value="dateTo"
    v-bind="$attrs"
    type="datetime"
    format="dd/MM/yy HH:mm"
    value-format="timestamp"
    placeholder="Selecciona fecha y hora"
    :picker-options="optionsPicker"
    v-on="$listeners"
    @focus="onFocus"
    @change="onChangeDatePickerTo"
  />
</template>

<script>
export default {
  name: "DatePickerToFuture",

  inheritAttrs: false,

  props: {
    value: Number,
  },

  data() {
    return {
      dateTo: null,
      optionsPicker: {
        disabledDate(time) {
          let d = new Date();
          var yesterday = new Date(d);
          yesterday.setDate(yesterday.getDate() - 1);
          return time.getTime() < yesterday;
        },
      },
    };
  },

  watch: {
    value(newValue) {
      this.dateTo = newValue;
    },
  },

  methods: {
    onFocus() {
      if (!this.dateTo) {
        this.dateTo = new Date().getTime();
      }
    },

    onChangeDatePickerTo() {
      let nowInSeconds = Math.floor(new Date().getTime() / 1000);
      if (this.dateTo !== null && this.dateTo / 1000 < nowInSeconds) {
        this.dateTo = new Date().getTime();
        this.$message({
          type: "info",
          message:
            "La fecha no puede ser anterior a la fecha y hora actual, se ha actualizado a fecha y hora actual",
        });
      }
      this.$emit("change-date-picker");
    },
  },
};
</script>
